// 活动专区
<template>
	<div class="bgf5">
		<div>
			<iHeader />
			<iNav />
			<iClassify :active="3" AllActive />
			<iRightFixedBox />
			<!-- 未满足参与条件bar -->
			<div class="warning-box" v-if="isShowAdd">
				<div class="center-box p-r">
					<div class="content">
						<span>您暂时未满足该专区活动参与条件</span>
						<!-- <a class="warning-a"
                           @click.stop="conditionModal = true">查看详情！</a> -->
					</div>
					<a-button type="primary" class="warning-btn" @click.stop="conditionModal = true">我要参与</a-button>
				</div>
			</div>
			<iPageTitle :text="pageTitle" />
			<!-- banner -->
			<div class="banner-box">
				<van-swipe class="swipe" :autoplay="5000" :duration="300" loop indicator-color="#126CE1">
					<van-swipe-item v-for="(img, index) in activityInfo.ActivityImages" :key="index">
						<img :src="img.Url" class="swiper-img" width="100%" fit="cover" />
					</van-swipe-item>
				</van-swipe>
			</div>
			<!-- token检验通过展示商品 -->
			<div class="content-box" v-if="isTokenOk && isRequstOk">
				<div class="header-box" :class="activityInfo.ShowGoodsTime == 3 ? 'header-box-show' : ''">
					<div class="left" v-if="activityInfo.ShowGoodsTime == 3 && activityInfo.countdownType == 1 && activityInfo.IsOpenPreActivity">
						<span>距活动开始仅剩</span>
						<span>{{ headTimer.d }} 天</span>
						<div class="time-box">{{ headTimer.h }}</div>
						<span>:</span>
						<div class="time-box">{{ headTimer.m }}</div>
						<span>:</span>
						<div class="time-box">{{ headTimer.s }}</div>
						<!-- 筛选(模糊查询输入框) -->
						<!-- <div class="search-box"><el-input v-model="SeachKey" placeholder="按商品名搜索" size="small"></el-input></div>
						<div class="search-box"><el-button type="primary" size="small" icon="el-icon-search" @click="serchHeald">搜索</el-button></div> -->
					</div>
					<div class="left" v-else-if="activityInfo.ShowGoodsTime == 3 && activityInfo.countdownType == 2">
						<span>距活动结束仅剩</span>
						<span>{{ headTimer.d }} 天</span>
						<div class="time-box">{{ headTimer.h }}</div>
						<span>:</span>
						<div class="time-box">{{ headTimer.m }}</div>
						<span>:</span>
						<div class="time-box">{{ headTimer.s }}</div>
						<!-- 筛选(模糊查询输入框) -->
						<!-- <div class="search-box"><el-input v-model="SeachKey" placeholder="按商品名搜索" size="small"></el-input></div>
						<div class="search-box"><el-button type="primary" size="small" icon="el-icon-search" @click="serchHeald">搜索</el-button></div> -->
					</div>
					<!-- 活动结束 && 设置为专区上展示倒计时 -->
					<div class="left" v-if="activityInfo.countdownType == 3 && activityInfo.ShowGoodsTime == 3"><span>活动已结束</span></div>
					<!-- 筛选分类 -->
					<div class="right-head">
						<div class="menu-head">
							<!-- 筛选(模糊查询输入框) -->
							<div class="search-box"><el-input v-model="SeachKey" placeholder="按商品名搜索" size="small"></el-input></div>
							<div class="search-box"><el-button type="primary" size="small" icon="el-icon-search" @click="serchHeald">搜索</el-button></div>
							<div class="btn-box" :class="{ active: navType == 1 }" @click.stop="navClick(1)">
								<span>综合</span>
								<span class="iconfont iconzonghe tag-icon"></span>
							</div>
							<div class="btn-box" :class="{ active: navType == 2 }" @click.stop="navClick(2)">
								<span>价格</span>
								<span class="iconfont iconqiehuan tag-icon" v-if="navType != 2"></span>
								<img src="@/assets/public/p-down.png" class="up-dowm-icon" v-if="IsPirceSort == 1 && navType == 2" alt="" />
								<img src="@/assets/public/p-up.png" class="up-dowm-icon" v-if="IsPirceSort == 2 && navType == 2" alt="" />
							</div>
							<div class="btn-box" :class="{ active: navType == 3 }" @click.stop="navClick(3)">
								<span>分类</span>
								<span class="iconfont iconfenlei tag-icon"></span>
							</div>
						</div>
					</div>
				</div>
				<!-- 分类筛选bar -->
				<div class="class-box" v-if="navType == 3 && classList.length">
					<div class="class-cell">
						<div class="class-item" v-for="(item, index) in classList" @click.stop="selectClass(item, 1)" :class="{ active: firstClass.Id == item.Id }" :key="index">
							{{ item.ClassifyName }}
						</div>
					</div>
					<div class="class-cell two-f" v-if="firstClass.Child && firstClass.Child.length">
						<div
							class="class-item"
							v-for="(item, index) in firstClass.Child"
							@click.stop="selectClass(item, 2)"
							:class="{ active: twoClass.Id == item.Id }"
							:key="index"
						>
							{{ item.ClassifyName }}
						</div>
					</div>
				</div>
				<!-- 活动未开始和结束面板提示 -->
				<div class="no-start" v-if="(moment().isBefore(activityInfo.BeginTime) && !activityInfo.IsOpenPreActivity) || moment(activityInfo.EndTime).isBefore(moment())">
					<div>
						<div v-if="moment().isBefore(activityInfo.BeginTime)">
							<div>该专区活动即将开始</div>
							<div>敬请期待</div>
						</div>
						<div v-if="moment(activityInfo.EndTime).isBefore(moment())">
							<div>该专区活动已结束</div>
							<div>请换一个专区试试吧</div>
						</div>
						<a-button type="primary" @click.stop="toIndex" class="btn-to">去逛逛其他的～</a-button>
					</div>
				</div>
				<!-- 活动进行中和开启预热时展示商品列表 -->
				<!-- 商品列表和分页 -->
				<div class="goods-content" v-else>
					<template v-if="dataList.length">
						<div class="goods-item" v-for="(item, index) in dataList" :key="index" @click.stop="toGoodsDetail(item, isShowAdd)">
							<special-goods-item
								:product="item"
								:isShowAdd="!activityInfo.IsAccord"
								:isZhuanQu="true"
								:activeCountdownType="activityInfo.countdownType"
								:timer="item.timer"
								:tags="activityInfo.ActivityTags"
								:isOldBuy="isOldBuy"
								:activeShowGoodsTime="activityInfo.ShowGoodsTime"
								:showGoodsTimeInGoods="activityInfo.ShowGoodsTime == 2"
								:IsOpenPreActivity="activityInfo.IsOpenPreActivity"
								:ConfigType="activityInfo.ConfigType"
								:firstAddWithOldBuyId="firstAddWithOldBuyId"
								@handleClick="handleClick"
							/>
						</div>
						<div class="paging"><iPagination :currentPage.sync="pageindex" :limit.sync="pageSize" :totalCount="totalCount" @turn="onLoad" small /></div>
					</template>
					<!-- <empty-tips v-else /> -->
				</div>
			</div>
			<iFooter />
			<!-- 弹窗部分 -->
			<!-- 参与条件弹窗 -->
			<div v-if="conditionModal" class="modal-box">
				<div class="modal-content">
					<div class="cond-bg">
						<div class="title">参与条件</div>
						<div class="disc">您暂时未满足该专区活动参与条件，如要参与需满足以下条件：</div>
						<div class="content" v-if="!!activityInfo.RuleText">
							<div class="list">
								<p v-for="(ruleItem, ruleIndex) in activityInfo.RuleText.split(';')" :key="ruleIndex" style="margin:0;">
									{{ ruleIndex + 1 }}、{{ ruleIndex > 0 ? activityInfo.ConditionRelation : '' }}{{ ruleItem }}。
								</p>
							</div>
						</div>
						<button class="btn" @click.stop="conditionModal = false">知道啦～</button>
					</div>
					<div class="close-box"><a-icon type="close-circle" class="icon-close" @click.stop="conditionModal = false" /></div>
				</div>
			</div>
			<!-- 不满足条件弹窗 -->
			<div v-if="joinModal" class="modal-box">
				<div class="modal-content">
					<div class="ncond-bg">
						<div class="title">温馨提示</div>
						<div class="disc">
							<div>您暂时未满足该专区活动参与条件，</div>
							<div>是否以原价购买该商品？</div>
						</div>
						<button class="btn" @click.stop="oldBuy">以原价购买</button>
						<button class="btn btn-s2" @click.stop="lookCond">查看参与条件</button>
					</div>
					<div class="close-box"><a-icon type="close-circle" class="icon-close" @click.stop="joinModal = false" /></div>
				</div>
			</div>
		</div>
		<!-- 令牌弹窗 -->
		<TokenModal :show="codeShow" :id="id" @ok="tokenOk" @close="tokenClose" />
	</div>
</template>

<script>
import TokenModal from '@/components/TokenModal';
import iHeader from '@/components/Header';
import iNav from '@/components/Nav';
import iClassify from '@/components/Classify';
import iPageTitle from '@/components/PageTitle';
import iFooter from '@/components/Footer';
import iRightFixedBox from '@/components/RightFixedBox';
import iPagination from '@/components/iPagination';
import { BaseMixin } from '../../mixins/BaseMixin';
import SpecialGoodsItem from '@/components/SpecialGoodsItem.vue';
// import EmptyTips from '@/components/EmptyTips.vue'
import moment from 'moment';

export default {
	mixins: [BaseMixin],
	components: {
		iHeader,
		iNav,
		iFooter,
		iRightFixedBox,
		iClassify,
		iPageTitle,
		iPagination,
		TokenModal, // 令牌弹窗组件
		SpecialGoodsItem // 专区商品item
		// EmptyTips,
	},
	watch: {
		$route: {
			handler(val, oldVal) {
				const {
					query: { id }
				} = val;
				const {
					query: { id: oldId }
				} = oldVal;
				if (id && oldId !== id) {
					window.location.reload();
					this.initPageInfo();
				}
			}
		}
	},
	data() {
		return {
			activeIsBegin: false, // 活动是否开始
			rightCommandCode: '', // 验证通过口令
			// 活动ID
			id: '',
			// 分类列表
			classList: [],
			// 活动信息
			activityInfo: {},
			// 活动倒计时对象
			headTimer: {},
			// 是否具备专区活动令牌
			isTokenOk: false,
			// 令牌请求是否完成
			isRequstOk: false,
			// 是否显示令牌弹窗
			codeShow: false,
			// 导航状态 1综合排序 2价格排序 3分类
			navType: 1,
			// 不满足参加专区活动的弹窗显示
			joinModal: false,
			// 不满足参加条件的提示弹窗显示
			conditionModal: false,
			// 商品列表
			dataList: [],
			// 价格排序 1升序 2降序
			IsPirceSort: 0,
			// 定时器集合
			intervalMap: [],
			// 活动倒计时定时器
			headInterVal: null,
			// 已选中的第一级分类
			firstClass: {},
			// 已选中的第二级分类
			twoClass: {},
			// 是否采用原价购买
			isOldBuy: false,
			// 分页信息
			pageTitle: [],
			pageindex: 1,
			pageSize: 10,
			totalCount: 0,
			// 是否有资格购买
			isShowAdd: false,
			firstAddWithOldBuyId: null, // 第一次原价加入购物车时商品id
			SeachKey: '' //模糊查询关键字
		};
	},
	beforeDestroy() {
		// 页面销毁时清除定时器
		if (this.intervalMap.length) {
			this.intervalMap.forEach(el => {
				clearInterval(el);
			});
			this.intervalMap = [];
		}
		// 如果有活动倒计时定时器则清除
		if (this.headInterVal) {
			clearInterval(this.headInterVal);
		}
	},
	created() {
		this.initPageInfo();
	},
	methods: {
		moment,
		initPageInfo() {
			this.id = this.$route.query.id;
			// 进入页面先请求是否需要令牌
			this.isHaveToken();
		},
		// 是否有资格购买回调
		handleClick(id) {
			this.joinModal = true;
			this.firstAddWithOldBuyId = id;
		},
		// 在令牌弹窗取消
		tokenClose() {
			// 返回首页
			// window.history.go(-1)
			this.$router.push({ path: '/' });
		},
		async initPageData() {
			this.$hys.openLoading();
			await this.getClassMenu();
			await this.getActivityInfo(); // 获取专区详情
			await this.loadData(); // 获取专区商品
			this.$hys.clearLoading();
		},
		// 令牌通过
		tokenOk(rightCommandCode) {
			this.rightCommandCode = rightCommandCode; // 验证通过口令
			this.initPageData();
			// 关闭弹窗
			this.codeShow = false;
			// 显示页面
			this.isTokenOk = true;
		},
		// 请求是否具有活动的令牌
		async isHaveToken() {
			let res = await this.postAction('/api_promotions/SalesPromotion/ActivityIsPwd', { Id: this.id });
			if (res.IsSuccess) {
				if (!res.Data) {
					// 无需令牌，直接显示页面 加载专区活动信息和商品列表
					this.initPageData();
				} else {
					// 需要输入专区令牌
					this.codeShow = true;
				}
				// 请求改变显示页面状态
				this.isTokenOk = !res.Data;
				this.isRequstOk = true;
			} else {
				if (res.Msg) {
					this.$toast.fail(res.Msg);
				}
			}
		},
		// 到商品详情
		toGoodsDetail(item) {
			console.log(this.activityInfo.ConfigType);
			console.log(this.activityInfo.RuleText);
			this._jump(
				this.Enum_LinkTypeCode.ProductDetails,
				{
					id: item.Id,
					detailType: 'specialOffer',
					configType: this.activityInfo.ConfigType,
					ruleText: this.activityInfo.RuleText,
					IsOpenPreActivity: this.activityInfo.IsOpenPreActivity,
					conditionRelation: this.activityInfo.ConditionRelation,
					activeIsBegin: this.activeIsBegin,
					isShowAdd: this.isShowAdd
				},
				'_blank'
			);
		},

		selectClass(item, val) {
			// 选中第一级 清空已选中第二级，如果是已选中的第一级则取消选中
			if (val == 1) {
				this.twoClass = {};
				if (this.firstClass.Id == item.Id) {
					this.firstClass = {};
				} else {
					this.firstClass = item;
				}
			}
			// 选中第二级 如果是已选中的第二级则取消选中
			if (val == 2) {
				if (this.twoClass.Id == item.Id) {
					this.twoClass = {};
				} else {
					this.twoClass = item;
				}
			}
			// 刷新列表
			this.loadData();
		},

		// 采用原价购买
		oldBuy() {
			// 改变状态转入商品组件，以便采用原始ID购买
			this.isOldBuy = true;
			// 关闭弹窗
			this.joinModal = false;
			// 改变为可以购买
			this.isShowAdd = true;
		},

		// 查看参与条件
		lookCond() {
			this.joinModal = false;
			this.conditionModal = true;
		},

		// 排序导航点击
		navClick(val) {
			this.navType = val;
			// 价格排序则升降对立
			if (val == 2) {
				if (this.IsPirceSort == 2) {
					this.IsPirceSort = 1;
				} else {
					this.IsPirceSort = 2;
				}
			}
			this.firstClass = {};
			this.twoClass = {};
			this.pageindex = 1;
			this.loadData();
		},

		// 查询分类信息
		async getClassMenu() {
			let res = await this.postAction('/api_promotions/SalesPromotion/GetActivityGoodsOperatingClassify', { Id: this.id, Type: 1 });
			if (res.IsSuccess) {
				this.classList = res.Data;
			}
		},

		// 打开我要参与条件
		openJoinModal() {
			this.joinModal = true;
		},

		//获取活动信息
		async getActivityInfo() {
			let res = await this.postAction('/api_promotions/SalesPromotion/GetCustomerActivitySpecialZoneDto', { Id: this.id, CommandCode: this.rightCommandCode || '' });
			if (res.IsSuccess) {
				this.activityInfo = res.Data;
				// 判断活动是否开始
				if (!moment().isBefore(this.activityInfo.BeginTime) && !moment(this.activityInfo.EndTime).isBefore(moment())) {
					this.activeIsBegin = true;
				}
				this.pageTitle = [res.Data.Name];
				this.activityInfo.ActivityImages = this.activityInfo.ActivityImages.filter(item => item.Type === 3);
				if (this.activityInfo.ActivityImages.length == 0) {
					this.activityInfo.ActivityImages.push({
						Url: require('@/assets/banner.png')
					});
				}

				// ShowGoodsTime
				// 不展示倒计时 = 1,
				// 商品上展示倒计时 = 2,
				// 专区上展示倒计时 = 3
				this._timeMillisecondsInterval(
					this.activityInfo.TotalMilliseconds,
					'headTimer',
					timer => {
						this.headTimer = timer;
					},
					timerIntVal => {
						this.headInterVal = timerIntVal;
					},
					() => {
						// 倒计时结束重新获取页面数据
						this.initPageData();
					}
				);
				// if(this.activityInfo.ShowGoodsTime == 3) {

				// }
			}
			// 获取资格
			this.isShowAdd =
				this.activityInfo.hasOwnProperty('IsAccord') &&
				!this.activityInfo.IsAccord &&
				((this.activityInfo.ShowGoodsTime === 3 && this.activityInfo.countdownType === 2) ||
					(this.activityInfo.ShowGoodsTime === 1 && this.activityInfo.countdownType === 0) ||
					(this.activityInfo.ShowGoodsTime === 2 && (this.activityInfo.countdownType === 0 || this.activityInfo.countdownType === 2)));
		},

		toIndex() {
			this.$router.push({ path: '/' });
		},

		//加载数据
		async loadData() {
			// 判断是按分类查询，分类ID级是否二级分类   分类ID如果有第二级的只传第二级
			var GoodsClassifyId = '';
			var IsChild = false;
			if (this.navType == 3) {
				if (this.firstClass.Id) {
					GoodsClassifyId = this.firstClass.Id;
					IsChild = false;
				}
				if (this.twoClass.Id) {
					GoodsClassifyId = this.twoClass.Id;
					IsChild = true;
				}
			}
			// 传入参数
			var params = {
				Id: this.id, // 活动ID
				pageNo: this.pageindex, // 第几页
				GoodsClassifyId, // 分类ID
				IsChild, // 分类是否第二级
				SeachKey: this.SeachKey, //关键字
				pageSize: this.pageSize, // 页条数
				IsPirceSort: this.navType == 2 ? this.IsPirceSort : 0, // 价格排序
				IsDefalutSort: this.navType == 1 // 是否综合排序
			};
			let res = await this.postAction('/api_promotions/SalesPromotion/GetCustomerActivitySpecialZoneGoods', params);
			// 如果有商品定时器集合，则清除
			if (this.intervalMap.length) {
				this.intervalMap.forEach(el => {
					clearInterval(el);
				});
				this.intervalMap = [];
			}
			if (res.IsSuccess) {
				this.dataList = res.Data;
				// 在商品上显示的倒计时
				this.dataList.forEach(el => {
					el.name = el.OperationName ?? el.SkuName;
					if (el.TotalMilliseconds) {
						this._timeMillisecondsInterval(
							el.TotalMilliseconds,
							'aGoods' + el.Id,
							timer => {
								el.timer = timer;
							},
							timerIntVal => {
								this.intervalMap.push(timerIntVal);
							}
						);
					}
				});
				this.totalCount = res.Count;
			}
		},
		//加载数据
		async onLoad() {
			await this.loadData();
		},
		/*
		 * 关键字模糊查询方法
		 */
		async serchHeald() {
			// console.log(this.SeachKey)
			await this.loadData(); // 获取专区商品
		}
	}
};
</script>

<style lang="less" scoped>
.adlist {
	margin-left: calc((99vw - 1200px) / 2);
	padding-top: 20px;
	width: 1200px;
	max-width: 1200px;
}
.class-box {
	width: 100%;
	background: #fff;
}
.class-cell {
	display: flex;
	flex-wrap: wrap;
	padding: 15px;
	padding-bottom: 0;
}
.two-f {
	border-top: 1px solid #eee;
}
.class-item {
	margin-right: 15px;
	cursor: pointer;
	margin-bottom: 15px;
	line-height: 1;
}
.class-cell .active {
	color: #0f6eea;
}
.class-item:hover {
	color: #0f6eea;
}
.banner-box {
	width: 1200px;
	height: 345px;
	margin: auto;
	margin-top: 20px;
}
.swiper-img {
	height: 345px;
}
.up-dowm-icon {
	width: 16px;
	height: 16px;
	margin-left: 2px;
}
.modal-box {
	position: fixed;
	z-index: 1000;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.6);
}
.close-box {
	color: #fff;
	margin-top: 20px;
}
.icon-close {
	cursor: pointer;
	font-size: 30px;
}
.ncond-bg {
	width: 372px;
	background: url('../../assets/activity-m.png');
	background-size: 100% 100%;
	box-sizing: border-box;
	padding: 24px 32px;
}
.cond-bg {
	width: 544px;
	background: url('../../assets/activity-m.png');
	background-size: 100% 100%;
	box-sizing: border-box;
	padding: 16px;
}
.modal-content {
	.title {
		color: #fff;
		font-size: 26px;
		text-align: center;
	}
	.disc {
		color: #fff;
		text-align: center;
		margin-top: 8px;
	}
	.content {
		background: #ffffff;
		box-shadow: 0px 0px 8px 0px #7fabff;
		border-radius: 12px;
		padding: 16px;
		margin-top: 20px;
		.list {
			margin-bottom: 8px;
			color: #111a34;
			text-align: left;
		}
	}
	.btn {
		width: 261px;
		height: 40px;
		background: linear-gradient(180deg, #ffec32 0%, #ffd417 100%);
		border-radius: 22px;
		color: #111a34;
		cursor: pointer;
		border: 0;
		margin-top: 12px;
	}
	.btn-s2 {
		background: #fff;
	}
}
.content-box {
	min-height: 500px;
	width: 1200px;
	margin: 0 auto;
	text-align: left;
	.goods-content {
		display: flex;
		flex-wrap: wrap;
		margin: -8px;
		padding-top: 12px;
		padding-bottom: 97px;
		.goods-item {
			width: 20%;
			padding: 8px;
			box-sizing: border-box;
		}
	}
	.no-start {
		padding: 114px 0;
		text-align: center;
		color: #111a34;
		font-size: 16px;
		.btn-to {
			width: 206px;
			height: 42px;
			background: #0f6eea;
			border-radius: 20px;
			font-size: 16px;
			margin-top: 20px;
		}
	}
	.header-box-show {
		background: #ff3939;
		padding: 0 10px;
		display: flex;
		align-items: center;
	}
	.header-box {
		width: 100%;
		height: 50px;
		border-radius: 2px;
		margin-top: 16px;
		.left {
			flex: 1;
			font-size: 22px;
			color: #fff;
			display: flex;
			align-items: center;
			line-height: 50px;
			.time-box {
				width: 35px;
				height: 27px;
				background: #111a34;
				border-radius: 4px;
				display: inline-block;
				text-align: center;
				line-height: 27px;
				color: #fff;
				margin: 0 8px;
			}
		}
		.right-head {
			.search-box {
				display: inline-block;
				margin-right: 14px;
				button {
					background-color: #0f6eea;
					border-color: #0f6eea;
				}
			}
		}
	}
}
.right-head {
	.menu-head {
		display: flex;
	}
	.tag-icon {
		font-size: 16px;
		margin-left: 2px;
	}
	color: #111a34;
	.btn-icon {
		width: 14px;
		height: 14px;
		vertical-align: top;
		margin-left: 4px;
	}
	.btn-box {
		width: 117px;
		height: 32px;
		background: #ffffff;
		border-radius: 2px 0px 0px 2px;
		border: 1px solid #c5cad5;
		border-right: 0;
		line-height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		&:hover {
			color: #0f6eea;
		}
	}
	.active {
		background: #0f6eea;
		color: #fff;
		border: 1px solid #0f6eea;
		&:hover {
			color: #fff;
		}
	}
	.btn-box:last-child {
		border-right: 1px solid #c5cad5;
	}
}
.warning-box {
	width: 100%;
	min-width: 1200px;
	height: 30px;
	background: #ff3939;
	text-align: center;
	.content {
		display: inline-block;
		color: #fff;
		line-height: 30px;
	}
	.warning-a {
		text-decoration: underline;
		color: #fff;
	}
	.warning-btn {
		height: 22px;
		background: #0f6eea;
		border-radius: 2px;
		position: absolute;
		z-index: 1;
		top: 0;
		bottom: 0;
		margin: auto;
		right: 0;
	}
}
.paging {
	width: 100%;
	display: flex;
	justify-content: center;
}
.center-box {
	width: 1200px;
	margin: 0 auto;
}
.p-r {
	position: relative;
}
</style>
